// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"383a1700d6d6307d","6457":"5d5c972cdb0613ec","9118":"dfc92c2fb0096253"}[chunkId] + ".js";
};